export default __webpack_public_path__ + "static/icon-tile-anatomy-dark-db013b34389e128adedc48ca36f926a7.png";